import { Injectable } from '@angular/core';
import { StudentDetails } from '@lx/quote-tool/shared/types';
import { GoogleAnalyticsStudentDetails } from '@lx/shared/google-analytics';
import { YesNo } from './yes-no.enum';

@Injectable({
  providedIn: 'root',
})
export class StudentDetailsDataLayerMapperService {
  /**
   * Maps the student details to a Google Analytics data layer object. Each property in the returned object corresponds to a specific field in the student details, indicating whether that field is present or not.
   */
  mapStudentDetailsToDataLayer(studentDetails: StudentDetails): GoogleAnalyticsStudentDetails {
    if (!studentDetails) {
      return undefined;
    }
    const marketingOptIn = studentDetails.consentMarketing ? YesNo.No : YesNo.Yes;

    if (studentDetails.title) {
      return {
        quote_enrol_title: YesNo.Yes,
        quote_enrol_name: studentDetails.firstName ? YesNo.Yes : YesNo.No,
        quote_enrol_lastname: studentDetails.lastName ? YesNo.Yes : YesNo.No,
        quote_enrol_birth: studentDetails.dateOfBirth ? YesNo.Yes : YesNo.No,
        quote_enrol_mothertongue: studentDetails.motherTongue ? YesNo.Yes : YesNo.No,
        quote_enrol_nationality: studentDetails.nationality ? YesNo.Yes : YesNo.No,
        quote_enrol_email: studentDetails.email ? YesNo.Yes : YesNo.No,
        quote_enrol_phone: studentDetails.phoneNumber ? YesNo.Yes : YesNo.No,
        quote_enrol_address: studentDetails.address ? YesNo.Yes : YesNo.No,
        quote_enrol_specialneeds: studentDetails.specialRequests ? YesNo.Yes : YesNo.No,
        quote_enrol_over18: studentDetails.isMinor ? YesNo.No : YesNo.Yes,
        quote_enrol_marketing_opt_in: marketingOptIn,
      };
    }

    return { quote_email_marketing_opt_in: marketingOptIn };
  }
}
